/**
 * Responsive derivatives for the finished-project screenshots.
 *
 * Originals stay in /skill-shots for source/master use. Public cards and the
 * moving sales strip only need bounded raster sizes, so they must go through
 * these helpers instead of shipping a 1400px PNG/JPEG by accident.
 */

export type SkillShotSource = `/skill-shots/${string}.${
  | "png"
  | "jpg"
  | "jpeg"}`;

export type SkillShotCardWidth = 480 | 960 | 1400;
export type SkillShotMarqueeWidth = 840 | 1280;

function sourceStem(source: SkillShotSource): string {
  if (!source.startsWith("/skill-shots/")) {
    throw new Error(`Invalid skill shot path: ${source}`);
  }

  return source
    .slice("/skill-shots/".length)
    .replace(/\.(?:png|jpe?g)$/i, "");
}

export function skillShotCardUrl(
  source: SkillShotSource,
  width: SkillShotCardWidth = 480,
): string {
  return `/skill-shots/cards/${sourceStem(source)}-${width}.webp`;
}

export function skillShotCardSrcSet(source: SkillShotSource): string {
  return `${skillShotCardUrl(source, 480)} 480w, ${skillShotCardUrl(source, 960)} 960w, ${skillShotCardUrl(source, 1400)} 1400w`;
}

export function skillShotMarqueeUrl(
  source: SkillShotSource,
  width: SkillShotMarqueeWidth = 840,
): string {
  return `/skill-shots/marquee/${sourceStem(source)}-${width}.webp`;
}

export function skillShotMarqueeSrcSet(source: SkillShotSource): string {
  return `${skillShotMarqueeUrl(source, 840)} 840w, ${skillShotMarqueeUrl(source, 1280)} 1280w`;
}
